import { render, staticRenderFns } from "./DashboardTemplate.vue?vue&type=template&id=075f2046&scoped=true&"
import script from "./DashboardTemplate.vue?vue&type=script&lang=js&"
export * from "./DashboardTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTemplate.vue?vue&type=style&index=0&id=075f2046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075f2046",
  null
  
)

export default component.exports